import { ShieldCheck, BadgeCheck, Lock, MessageSquare, Scale, Phone } from "lucide-react";
import config from "../../config/stateConfig";

const PROMISES = [
  {
    icon: ShieldCheck,
    title: "No fees unless they win",
    desc: "Every attorney in our network works on a contingency basis. No upfront cost, no hourly billing — and nothing owed if your case doesn't recover.",
  },
  {
    icon: Lock,
    title: "Your conversation is private",
    desc: "We never sell your information. Once you're connected with an attorney, your conversation is protected by attorney–client privilege.",
  },
  {
    icon: Phone,
    title: "Free, no-obligation consultation",
    desc: "Talk with an attorney about your case at no cost. They'll review the facts, explain your options, and answer every question. You decide what to do next.",
  },
  {
    icon: Scale,
    title: `${config.stateName} attorneys, ${config.stateName} courts`,
    desc: `We connect you with attorneys licensed in ${config.stateName} who know your county courts, local hospitals, and the specific laws that affect your claim.`,
  },
  {
    icon: BadgeCheck,
    title: "Educational, never pushy",
    desc: "Our role is to help you understand what's happening and connect you with the right person. If you decide not to move forward, that's fine — no pressure, no follow-up calls.",
  },
  {
    icon: MessageSquare,
    title: "Available 24/7",
    desc: "Accidents don't follow business hours. Reach out by phone or form any time, day or night, weekend or holiday — someone is there.",
  },
];

export default function OurPromise() {
  return (
    <section className="section bg-forest text-bone relative overflow-hidden" data-testid="promise-section">
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")',
        }}
      />
      <div className="max-w-7xl mx-auto relative">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-terracotta mb-3">
            What you can expect
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-bone tracking-tight mb-4 text-balance">
            A clear, honest standard. Every time.
          </h2>
          <p className="text-base md:text-lg text-bone/70 leading-relaxed">
            We're not a law firm — we're a free service that connects {config.stateName} accident victims
            with attorneys. Here's what we commit to, regardless of what your case looks like.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {PROMISES.map((p, idx) => (
            <div
              key={idx}
              className="bg-bone/5 border border-bone/10 rounded-2xl p-6 md:p-7 backdrop-blur-sm hover:bg-bone/10 transition-colors"
              data-testid={`promise-${idx}`}
            >
              <div className="w-11 h-11 rounded-xl bg-terracotta/15 text-terracotta grid place-items-center mb-4">
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-lg md:text-xl text-bone mb-2 leading-tight">
                {p.title}
              </h3>
              <p className="text-sm md:text-base text-bone/70 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
